import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import styled from 'styled-components';
import { Absolute, Box } from 'rebass';

const MiddleCenterOverlay = styled(Absolute)`
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  z-index: 1000;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.85);
  transition: background-color 0.5s linear;
`;

const HorizontalCenter = styled(Box)`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const LOADING_MODE = {
  ROBOT: 'ROBOT',
  MINIBOT: 'MINIBOT',
  LOADING: 'LOADING',
};

let robot = null;
let loading = null;
let minibot = null;

function loadAnimationData(mode) {
  return require('./animation/' + mode + '.json');
}

function getAnimationData(mode) {
  switch (mode) {
    case LOADING_MODE.ROBOT:
      if (robot) return robot;
      robot = loadAnimationData(LOADING_MODE.ROBOT.toLowerCase());
      return robot;
      break;
    case LOADING_MODE.MINIBOT:
      if (minibot) return minibot;
      minibot = loadAnimationData(LOADING_MODE.MINIBOT.toLowerCase());
      return minibot;
      break;
    case LOADING_MODE.LOADING:
      if (loading) return loading;
      loading = loadAnimationData(LOADING_MODE.LOADING.toLowerCase());
      return loading;
      break;
    default:
      break;
  }
}

class RobotLoading extends Component {
  static propTypes = {
    mode: PropTypes.oneOf(Object.values(LOADING_MODE)),
    width: PropTypes.number,
    height: PropTypes.number,
    dimmer: PropTypes.bool,
  };

  static defaultProps = {
    mode: LOADING_MODE.MINIBOT,
    width: 60,
    height: 60,
    dimmer: true,
  };

  render() {
    const { mode, width, height, dimmer } = this.props;
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: getAnimationData(mode),
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    const PlacementComp = dimmer ? MiddleCenterOverlay : HorizontalCenter;
    return (
      <PlacementComp>
        <Lottie options={defaultOptions} height={height} width={width} />
      </PlacementComp>
    );
  }
}

RobotLoading.MODE = LOADING_MODE;

export default RobotLoading;
